import styled from 'styled-components'

export const Image = styled.img`
  width: 100px ;
  margin-top: 50px;
`
